
interface IconsProps {
    onClick?:()=>void;
    fill?:string;
    stroke?:string;
    width?:string | number;
    height?:string | number;
}
const Invoice = ({onClick,fill,stroke,width = '16px',height = '16px'}:IconsProps):JSX.Element => {
    return(
        <svg width={width} height={height} onClick={onClick}  xmlns="http://www.w3.org/2000/svg" fill={fill ??"none"} viewBox="0 0 24 24">
    <path
      id="SVGRepo_iconCarrier"
      stroke={stroke ?? "#000"}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M13 3H8.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C5 4.52 5 5.08 5 6.2v11.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C6.52 21 7.08 21 8.2 21h7.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C19 19.48 19 18.92 19 17.8V9m-6-6 6 6m-6-6v4.4c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C13.76 9 14.04 9 14.6 9H19m-7 3c-1.997 0-1.998.486-2 1.33v.002c-.002.9 0 1.168 2 1.168s2 .206 2 1.167C14 16.389 14 17 12 17m0-5h2m-2 0v-1m0 6h-2m2 0v1"
    ></path>
  </svg>
    );
}
const Graph = ({onClick,fill,stroke,width = '16px',height = '16px'}:IconsProps):JSX.Element => {
    return(
        <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="Layer_1"
    width={width} height={height} onClick={onClick} 
    fill={fill ??"none"}
    version="1.1"
    viewBox="0 0 187.628 187.628"
  >
    <g id="SVGRepo_iconCarrier">
      <path d="M52.216 58.587c-.024.164-.097.311-.097.482v3.475a3.475 3.475 0 0 0 6.95 0V59.85c7.492-.459 13.464-6.64 13.464-14.245 0-7.307-5.517-13.286-12.592-14.156-.285-.076-.563-.176-.872-.176-3.832 0-6.949-3.117-6.949-6.949s3.117-6.949 6.949-6.949a6.956 6.956 0 0 1 6.949 6.949 3.475 3.475 0 0 0 6.95 0c0-7.664-6.235-13.898-13.898-13.898V6.95a3.475 3.475 0 0 0-6.95 0v5.408c-4.134 2.411-6.949 6.844-6.949 11.965 0 7.068 5.322 12.855 12.159 13.722.285.076.562.176.871.176 4.072 0 7.383 3.312 7.383 7.383s-3.312 7.383-7.383 7.383-7.383-3.312-7.383-7.383a3.475 3.475 0 0 0-6.95 0c-.001 5.762 3.435 10.707 8.348 12.983M170.254 38.221c-9.579 0-17.373 7.794-17.373 17.373 0 5.777 2.864 10.869 7.216 14.03l-38.766 81.125a17.3 17.3 0 0 0-6.67-1.341c-3.4 0-6.552 1.019-9.234 2.714l-32.684-44.247c2.282-2.94 3.697-6.584 3.697-10.586 0-9.579-7.794-17.373-17.373-17.373S41.694 87.71 41.694 97.289c0 4.434 1.72 8.442 4.464 11.515-.043.044-.101.062-.142.109l-21.424 24.741c-2.206-1.016-4.638-1.621-7.221-1.621C7.794 132.035 0 139.829 0 149.408s7.794 17.373 17.373 17.373 17.373-7.794 17.373-17.373c0-4.48-1.75-8.529-4.545-11.614l21.07-24.333c.147-.169.209-.374.317-.56 2.275 1.095 4.791 1.761 7.48 1.761 3.057 0 5.889-.862 8.388-2.255l32.904 44.545a17.26 17.26 0 0 0-3.071 9.828c0 9.579 7.794 17.373 17.373 17.373s17.373-7.794 17.373-17.373c0-4.682-1.881-8.92-4.904-12.048l39.291-82.224c1.237.281 2.512.458 3.833.458 9.579 0 17.373-7.794 17.373-17.373s-7.795-17.372-17.374-17.372M17.373 159.832c-5.748 0-10.424-4.676-10.424-10.424s4.676-10.424 10.424-10.424c2.044 0 3.938.613 5.55 1.633.045.044.064.103.112.145.168.145.367.218.551.325 2.541 1.903 4.211 4.909 4.211 8.321 0 5.748-4.676 10.424-10.424 10.424m41.695-52.119c-5.748 0-10.424-4.676-10.424-10.424s4.676-10.424 10.424-10.424 10.424 4.676 10.424 10.424-4.676 10.424-10.424 10.424m55.593 69.491c-5.748 0-10.424-4.676-10.424-10.424s4.676-10.424 10.424-10.424c2.032 0 3.915.608 5.52 1.617.306.356.68.662 1.131.877.016.008.033.004.049.011 2.258 1.913 3.724 4.734 3.724 7.919 0 5.749-4.676 10.424-10.424 10.424m55.593-111.186c-5.748 0-10.424-4.676-10.424-10.424s4.676-10.424 10.424-10.424 10.424 4.676 10.424 10.424-4.676 10.424-10.424 10.424"></path>
    </g>
  </svg>
    );
}
const Anomaly = ({onClick,fill,stroke,width = '16px',height = '16px'}:IconsProps):JSX.Element => {
    return(
         <svg width={width} height={height} onClick={onClick}  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
    <g id="SVGRepo_iconCarrier">
      <g
        id="Page-1"
        fill="none"
        fillRule="evenodd"
        stroke="none"
        strokeWidth="1"
      >
        <path
          id="Shape"
          fill={fill ?? "#000"}
          d="M170.667 0c94.104 0 170.666 76.563 170.666 170.667 0 39.373-13.534 75.573-36.018 104.481L426.63 396.464l-30.166 30.166-121.316-121.315c-28.908 22.484-65.108 36.018-104.481 36.018C76.563 341.333 0 264.771 0 170.667S76.563 0 170.667 0m0 148.928L133.408 240l-70.296.001c22.817 35.275 62.504 58.666 107.555 58.666 45.05 0 84.737-23.39 107.555-58.666L207.925 240zm0-106.261c-70.584 0-128 57.416-128 128 0 12.982 1.942 25.518 5.551 37.334l63.697-.001 58.752-143.59L229.397 208l63.718.001c3.61-11.816 5.552-24.352 5.552-37.334 0-70.584-57.417-128-128-128"
          transform="translate(42.667 42.667)"
        ></path>
      </g>
    </g>
  </svg>
    );
}
export const Icons = {
    Invoice,
    Graph,
    Anomaly
}